module.exports = __webpack_public_path__ + "img/nick-liefhebber-wild-flower.4fd7090.jpg";